export const PHONE_CHANGE_STEP = {
  PHONE: 'phone',
  OTP: 'otp',
} as const;

export type PhoneChangeStep = (typeof PHONE_CHANGE_STEP)[keyof typeof PHONE_CHANGE_STEP];

export const PHONE_CHANGE_COPY = {
  phoneTitle: 'Change mobile number',
  phoneSubtitle: "We'll send a 6-digit code to your new number",
  phoneLabel: 'New mobile number',
  sendCode: 'Send OTP',
  otpTitle: 'Enter code',
  otpSubtitle: 'Enter the 6-digit code we sent to your new number',
  otpLabel: 'Enter OTP',
  change: 'Change',
  resend: 'Resend OTP',
  resendIn: (time: string) => `Resend OTP in ${time}`,
  whatsapp: 'Get it on WhatsApp',
  sms: 'Get it by SMS',
  verify: 'Verify & update',
  sendFailed: "Couldn't send the code. Please try again.",
  wrongCode: "That code doesn't match. Please try again.",
  signOutNote: 'Other devices will be signed out after the change.',
};
